export default function DescargarApp() {
  const APK_URL = "https://importacionesby.com/uploads/app/ImportacionesBY-Admin.apk";

  return (
    <div style={{ display: "flex", justifyContent: "center", paddingTop: "20px" }}>
      <div style={{
        background: "#fff", borderRadius: "24px", padding: "40px", maxWidth: "480px",
        width: "100%", textAlign: "center", boxShadow: "0 4px 24px rgba(0,0,0,0.08)",
      }}>
        <div style={{
          width: "96px", height: "96px", borderRadius: "24px", margin: "0 auto 24px",
          background: "linear-gradient(135deg, #0D47A1, #1565C0)",
          display: "flex", alignItems: "center", justifyContent: "center",
          fontSize: "44px", boxShadow: "0 8px 20px rgba(13,71,161,0.35)",
        }}>
          📲
        </div>

        <h1 style={{ fontFamily: "Montserrat,sans-serif", fontWeight: 900, fontSize: "22px", color: "#1a1a2e", marginBottom: "8px" }}>
          App Importaciones B&Y
        </h1>
        <p style={{ color: "#6b7280", fontSize: "14px", marginBottom: "28px", lineHeight: 1.5 }}>
          Instalá la app en tu celular para acceder al panel administrativo
          y recibir notificaciones cuando se acerquen las fechas de cobro.
        </p>

        <a href={APK_URL} download
          style={{
            display: "block", background: "#0D47A1", color: "#fff", textDecoration: "none",
            padding: "16px", borderRadius: "14px", fontWeight: 800, fontSize: "16px",
            fontFamily: "Nunito,sans-serif", marginBottom: "20px",
          }}>
          ⬇️ Descargar para Android
        </a>

        <div style={{ textAlign: "left", background: "#F9FAFB", borderRadius: "14px", padding: "18px 20px", fontSize: "13px", color: "#4b5563", lineHeight: 1.7 }}>
          <div style={{ fontWeight: 800, color: "#1a1a2e", marginBottom: "6px" }}>Cómo instalarla:</div>
          1. Tocá el botón de arriba para descargar el archivo <code>.apk</code><br />
          2. Abrí el archivo descargado desde las notificaciones o el gestor de archivos<br />
          3. Si Android pregunta, permití "Instalar apps de fuentes desconocidas"<br />
          4. Abrí la app e iniciá sesión con tu usuario del panel<br />
          5. Aceptá el permiso de notificaciones cuando te lo pida
        </div>

        <div style={{ marginTop: "16px", fontSize: "12px", color: "#9ca3af" }}>
          Disponible solo para Android por ahora.
        </div>
      </div>
    </div>
  );
}
